import {Component, OnInit} from '@angular/core';
import {BreadcrumbItem} from '../../../models/breadcrumb/breadcrumb-item';
import {translate} from '@jsverse/transloco';
import {Solution} from '../../../models/service/solution';
import {Router} from '@angular/router';
import {AuthService} from '../../../services/auth/auth.service';
import {RouterSegments} from 'src/app/models/router-segments';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from 'src/app/components/video-dialog/video-dialog.component';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE
  }
];

@Component({
    selector: 'app-composable-banking',
    templateUrl: './composable-banking.component.html',
    styleUrls: ['./composable-banking.component.scss'],
    standalone: false
})
export class ComposableBankingComponent implements OnInit {

  breadcrumbItems: BreadcrumbItem[];
  RouterSegments = RouterSegments;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };

  constructor(private authService: AuthService, private router: Router, private matDialog: MatDialog, private permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.configureBreadcrumb();
  }

  goToComposeService(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.COMPOSE]);
  }

  openVideo(): void {
    this.matDialog.open(VideoDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      data: {
        videoHref: 'https://player.vimeo.com/video/779366544'
      }
    });
  }

  private configureBreadcrumb(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({label: translate('COMPOSABLE_BANKING.HOME'), url:[]});
    this.breadcrumbItems.push({label: translate('COMPOSABLE_BANKING.COMPOSABLE_BANKING')});
  }

}
